export const GET_ESTADISTICAS_AVISO = 'GET_ESTADISTICAS_AVISO'
export const GET_ESTADISTICAS_AVISO_SUCCESS = 'GET_ESTADISTICAS_AVISO_SUCCESS'
export const GET_ESTADISTICAS_AVISO_ERROR = 'GET_ESTADISTICAS_AVISO_ERROR'

export interface ItemPostulaciones {
  fecha: string
  cantidad: number
}

export interface ItemEdades {
  age: string
  count: number
}
export interface ItemNivelesEducacion {
  data: [
    {
      level: string
      done: number
      inProgress: number
      incomplete: number
    }
  ]
}
export interface ItemExpectativaSalarial {
  salario: number
  cantidad: number
}
export interface ItemGenero {
  gender: string
  count: number
}

export interface EstadisticasAviso {
  id: number
  nombre: string
  estadoAviso: string
  publicacion: string
  finalizacion: string
  totalCV: number
  totalCVNoLeidos: number
  postulacionesHoy: number
  cumplenRequisitos: string
  visitas: number
  ultimaModificacion: string
  postulaciones: ItemPostulaciones[]
  edades: ItemEdades[]
  nivelesEducacion: ItemNivelesEducacion[]
  salarioPromedio: number
  expectativaSalarial: ItemExpectativaSalarial[]
  genero: ItemGenero[]
}

export interface GetEstadisticasAviso {
  type: typeof GET_ESTADISTICAS_AVISO
  payload: null
}

export interface GetEstadisticasAvisoSuccess {
  type: typeof GET_ESTADISTICAS_AVISO_SUCCESS
  payload: EstadisticasAviso
}

export interface GetEstadisticasAvisoError {
  type: typeof GET_ESTADISTICAS_AVISO_ERROR
  payload: boolean
}

export interface EstadisticasState {
  estadisticasAviso: EstadisticasAviso | null
  loading: boolean
  error: boolean
}

export const InitialStateEstadisticas: EstadisticasState = {
  estadisticasAviso: null,
  loading: true,
  error: false,
}

export type EstadisticasActions = GetEstadisticasAviso | GetEstadisticasAvisoSuccess | GetEstadisticasAvisoError
